import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useExperimentIsEnabled } from '@/services/experiments';
import { OptimizelyFlags } from '@/services/experiments/flags';

import { AnimatedHeadline } from './AnimatedHeadline';

type THeadlineProps = {
  value: Array<string | string[]>;
};

export const Headline = ({ value }: THeadlineProps) => {
  const isRentalsVDeliverySearchModeEnabled = useExperimentIsEnabled(
    OptimizelyFlags.RENTAL_V_DELIVERY_SEARCH_MODE,
  );

  return (
    <>
      {isRentalsVDeliverySearchModeEnabled && (
        <Text
          variant={ETextStyleVariant.Label}
          className="pt-0 tracking-wider md:text-[16px] md:pt-5 lg:pt-7">
          <FormattedMessage defaultMessage="ROADTRIP RVS" id="Gjz5Vx" />
        </Text>
      )}
      <Heading
        component="div"
        variant={EHeadingStyleVariant.H1Alt}
        className={cn(
          'flex flex-col not-italic font-normal break-words lg:mb-8 lg:mt-2 text-[32px] md:text-[72px] leading-10 md:leading-none md:mt-2',
          {
            'mt-0 mb-8 md:mb-10 lg:mb-8': isRentalsVDeliverySearchModeEnabled,
            'mb-4': !isRentalsVDeliverySearchModeEnabled,
          },
        )}>
        {value.map((v, index) => {
          if (typeof v === 'string' || v.length === 1) {
            return <span key={index}>{Array.isArray(v) ? v[0] : v}</span>;
          }

          return v.length > 1 ? <AnimatedHeadline key={index} value={v} /> : null;
        })}
      </Heading>
    </>
  );
};
